import { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import CurrencyFormater from "../../shared/ui/Currency.Input";
import loanSelling from "../../services/soldLoans/connector";
import moment from "moment";

const TableCellLoanActions = ({ item, sellLoan }) => {
  const [open, setOpen] = useState(false);
  const [originalAmount, setOriginalAmount] = useState();
  const [soldAmount, setSoldAmount] = useState();
  const [soldDate, setSoldDate] = useState(new Date());

  useEffect(() => {
    setOriginalAmount(item.DueAndOverdue.Amount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSoldAmount(getSoldAmount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getSoldAmount() {
    return item.DueAndOverdue.Amount * 0.806;
  }

  const roundAmount = (n, k) => {
    let factor = Math.pow(10, k);
    return Math.round(n * factor) / factor;
  };

  const handleSellingLoanClose = () => {
    setOpen(false);
    const roundedSoldAmount = roundAmount(soldAmount, 4);
    sellLoan(
      item.IntId,
      moment(soldDate).format("YYYY-MM-DD"),
      roundedSoldAmount,
      item.Id,
    );
  };

  return (
    <div className="table-cell-actions">
      <Button fullWidth={true} onClick={() => setOpen(true)}>
        Sell loan
      </Button>
      <Dialog
        modal={false}
        open={open}
        onClose={() => {
          handleSellingLoanClose();
        }}
      >
        <DialogTitle>Setting loan to sold</DialogTitle>
        <DialogContent>
          Selling loan with id:{item.Id}
          <br />
          <DatePicker
            inputVariant="outlined"
            className="small-datepicker"
            value={soldDate}
            onChange={(date) => {
              setSoldDate(date);
            }}
            label="Bank sold date"
          />
          <br />
          Original amount
          <br />
          <CurrencyFormater
            disabled={true}
            value={originalAmount}
            onChange={(event) => {
              setOriginalAmount(event.target.value);
            }}
            hintText="Original amount"
          />
          <br />
          Sold amount
          <br />
          <CurrencyFormater
            value={soldAmount}
            onChange={(event) => {
              setSoldAmount(event.target.value);
            }}
            hintText="Sold amount"
          />
          <br />
        </DialogContent>
        <DialogActions>
          <Button
            key="Sell loan"
            primary={true}
            keyboardFocused={true}
            onClick={() => {
              handleSellingLoanClose();
            }}
          >
            Sell loan
          </Button>
          <Button
            key="Close"
            primary={false}
            keyboardFocused={false}
            onClick={() => {
              setOpen(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default loanSelling(TableCellLoanActions);
